<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
  <p class="text-white">{{ 'global.loading.text' | translate }}</p>
</ngx-spinner>

<router-outlet></router-outlet>
